/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import { z } from 'zod'
import { useTranslation } from 'react-i18next'
import { useMemo } from 'react'

export const useBookingSellerVoucherSchema = () => {
    const { t } = useTranslation()

    return useMemo(() => z.object({
        priceDiscount: z
            .number({message: t('Price discount must be a number')})
            .int(t('Price discount must be a whole number'))
            .min(0, t('Price discount must be at least 0'))
            .max(1000, t('Price discount must not exceed 1000')),
    }), [t])
}

export type BookingSellerVoucherInputs = z.infer<ReturnType<typeof useBookingSellerVoucherSchema>>
